module.exports = __webpack_public_path__ + "img/paper.5f51e9c9.svg";